import InternalStorageBaseScreen from "../../../../mapping_tool/UpdateNodes/shared/internalStorage/InternalStorageBaseScreen";

export const ProcessInternalStorageBase = ({ modalData }: { modalData: any }) => (
  <InternalStorageBaseScreen modalData={modalData} gate="process" variant="simulate" />
);
